// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"e4ff9e97","461":"57d0bd73","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};